import React from 'react';
import styled from 'styled-components';

import WizardFooter from './elements/WizardPageSelector';
import Alert from './elements/Alert';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const WizardForm = ({ page: Page, onSubmit, alert, ...other }) => (
  <Wrapper>
    <Content>
      <Page onSubmit={onSubmit} />
    </Content>
    {alert && <Alert>{alert}</Alert>}
    <WizardFooter {...other} />
  </Wrapper>
);

export default WizardForm;
